export const getServiceType = (serviceType) => {
    if (serviceType) {
        if (serviceType.toLowerCase().includes('voce') || serviceType.toLowerCase().includes('plafond')) {
            return 'VOCE E DATI'
        } else {
            return 'DATI'
        }
    }
    return ''
}

export const TABLE_SIZE_XS = "10%"
export const TABLE_SIZE_S = "15%"
export const TABLE_SIZE_M = "20%"
export const TABLE_SIZE_L = "30%"
export const TABLE_SIZE_XL = "60%"